module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-database-4.5a3652cf.svg";